/* ------------------------------------------------------------------------ */
/*		File: cmpCard_703.tsx                                               */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ICard } from "./cmpCard_703.d";
import { getImage } from "../GenericComponents/functions";
import "./cmpCard_703.css";

/* ------------------------------------------------------------------------ */

const Card_703: React.FC<ICard> = ({card}: ICard) => {
    const navigate = useNavigate();
    const [typeElement, setTypeElement] = useState<string>("blog");

    useEffect(()=> {
        if (card && card.type !== undefined) {
            const tmp = card.type as string;
            switch(tmp) {
                case "01": setTypeElement("blog"); break; 
                case "02": setTypeElement("news"); break; 
                default: setTypeElement("other"); break; 
            }
        }
    }, []) 

    return (
        <>
            {card !== null && (
                <div className="card_703">
                    <div className="card_703_image">
                        {card !== null && card.src !== null && <img src={getImage(card!.src)} alt={card!.src} />}
                    </div>
                    <div 
                        className="card_703_content"
                        onClick={() => navigate(`/Resources/detail/${card!.id}`)} 
                    >
                        <div className="card_703_content_one">
                            <div className="card_703_content_one_title">
                                <div className={`square_${typeElement}`}/>
                                <p className="blog_paragraph">{card!.title}</p>
                            </div>
                            <div className="card_703_content_one_date">
                                <div className="icon">
                                    <img src={getImage("clock.svg")} alt="clock.svg"/>
                                </div>
                                {new Date(card!.createdAt!).toLocaleString()}
                            </div>
                        </div>
                            <div className="card_703_content_one_text">
                                <div dangerouslySetInnerHTML={{ __html: card!.short! }}/>
                                <img 
                                    src={getImage("more.svg")} 
                                    alt="more.svg"
                                    className="icon"
                                    onClick={() => navigate(`/Resources/detail/${card!.id}`)} 
                                />
                            </div>
                    </div>
                </div>
        )}</>
    );
};
export default Card_703; 